

const state = {
  message: null,
  error: null,
  thirdPartyError: false,
}


const getters = {
  // getCompleted( state ) {
  //    return state.completed
  // },
}

const actions = {

  setError({ commit }, error) {
    commit('SET_MESSAGE', error.message)
    commit('SET_ERROR', error.error)
    console.error(error.error)
  },

  clearError({commit}) {
    commit('SET_MESSAGE', null)
    commit('SET_ERROR', null)
  },
  
  // pushHistory({ commit }, payload) {
  //     // let current = JSON.stringify(state.history[state.history.length-1])
  //     // if (JSON.stringify(payload) !== current)
  //     commit('PUSH_HISTORY', payload)
  // },

}

const mutations = {

  SET_MESSAGE(state, message) {
    state.message = message
  },

  SET_ERROR(state, error) {
    state.error = error
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}